<script setup>
import { useWidgetSettings } from '../composables/useWidgetSettings'

const { isHomePage } = useIsHomePage()
const { isRouteResolved } = useIsRouteResolved()
const { isWidget } = useWidgetSettings()
const { topMarginClasses, topPositionClasses } = useHeaderConfig()
const { isPeloton } = useEnterpriseClient()

const isMounted = ref(false)
onMounted(() => isMounted.value = true)
const loading = computed(() => !isMounted.value || isHomePage.value === undefined || !isRouteResolved.value)

const route = useRoute()
const pageClasses = toRef(() => route?.meta?.page_classes)
const stickyContainerClasses = toRef(() => route?.meta?.sticky_container_classes)
</script>

<template>
  <DSLoadingWrapper :loading="loading">
    <AppHeader v-if="!isWidget" />
    <div
      class="flex flex-row bg-[--theme-color-underlay-background]"
      :class="[topMarginClasses, ...(!isWidget ? ['pt-4'] : ['lt-sm:pt-4'])]"
    >
      <div
        id="sidebar-portal"
        class="w-fit"
      />
      <div
        class="page-main w-full flex grow flex-col flex-gap-y-4"
        :class="pageClasses"
      >
        <AppSwitchToMobileButton v-if="!isPeloton" />
        <AppMobilePageHeader v-if="!isHomePage" />
        <AppBannersAboveNavMenu />
        <AppNavMenu v-if="!isHomePage" />
        <AppBannersBelowNavMenu v-if="!isHomePage" />
        <div>
          <slot />
        </div>
        <AppFooter />
      </div>
    </div>
    <AppNavMenuMobileDrawer />
  </DSLoadingWrapper>
  <div
    id="sticky-container"
    class="fixed left-0 right-0 z-sticky mx-4"
    :class="[topPositionClasses, stickyContainerClasses]"
  />
</template>
